<section class="voice-insurance-type">
  <div class="title">Forsikring</div>
  @if (mobileInsuranceNotAllowed) {
    <div class="insurance-info-box">
      @if (!!insuranceOptionControl.value && isInsurancesAvailable) {
        <app-ice-alert
          [iconName]="IconNames.ice_warning"
          [type]="insuranceOptionControl.value === InsuranceOptionNames.NoInsurance ? 'info' : 'error'"
        >
          Kunden må ha minimum ett aktivt mobilabonnement for å kunne velge mobilforsikring.
        </app-ice-alert>
      }
    </div>
  }
</section>

@if (!mobilePhoneVariant) {
  <br />
  @if (gtinControl.value && gtinControl.valid) {
    <app-ice-alert type="info">
      Fant ingen telefon i ice sin katalog på oppgitt EAN/GTIN-nummer. Vi kan derfor ikke tilby mobilforsikring.
    </app-ice-alert>
  } @else {
    <app-ice-alert type="info">Skann eller tast inn EAN/GTIN for å se tilgjengelige mobilforsikringer</app-ice-alert>
  }
}
@if (insuranceOptions) {
  <div class="insurance-selling-point-container">
    <app-ice-select-box
      label="Ingen forsikring"
      radioTestId="no-insurance-input"
      type="radio"
      [control]="insuranceOptionControl"
      [value]="InsuranceOptionNames.NoInsurance"
    />
    @for (option of insuranceOptions; track option.offeringId) {
      <app-ice-select-box type="radio" [control]="insuranceOptionControl" [label]="option.name" [value]="option.offeringId">
        <div inlineHeaderContent>
          @if (option.priceInformation.isDiscounted) {
            <span class="original-price">
              {{ option.priceInformation.originalPrice?.includingVAT | priceFormat: PriceType.OneTime }}
            </span>
          }
          <span class="price">
            {{ option.priceInformation.price?.includingVAT | priceFormat: PriceType.Monthly }}
          </span>
        </div>
        <div class="insurance-info" header>
          <div class="insurance-list">
            @if (option.name === InsuranceOptionNames.Skadeforsikring) {
              <div>
                <div class="insurance-selling-point">
                  <span>
                    <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
                  </span>
                  <span>Skade på mobil og skjerm</span>
                </div>
                <div class="insurance-selling-point">
                  <span>
                    <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
                  </span>
                  <span>Væskeskade</span>
                </div>
              </div>
            }
            @if (option.name === InsuranceOptionNames.Plussforsikring) {
              <div>
                <div class="insurance-selling-point">
                  <span>
                    <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
                  </span>
                  <span>Skade på mobil og skjerm</span>
                </div>
                <div class="insurance-selling-point">
                  <span>
                    <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
                  </span>
                  <span>Væskeskade</span>
                </div>
                <div class="insurance-selling-point">
                  <span>
                    <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
                  </span>
                  <span>Tapt telefon</span>
                </div>
                <div class="insurance-selling-point">
                  <span>
                    <mat-icon [svgIcon]="IconNames.ice_tick_fat" />
                  </span>
                  <span>Stjålet telefon</span>
                </div>
              </div>
            }
          </div>
          @if (isDiscounted(option)) {
            <app-ice-badge class="discount-price" type="neutral">
              {{ option.priceInformation.discountPercentage | number: '1.0-0' }}% rabatt i
              {{ option.priceInformation.discountLength }} måneder
            </app-ice-badge>
          }
        </div>
      </app-ice-select-box>
    }
  </div>
}
